import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ppaUrls } from 'config/urls';
import { WorkflowCardData } from 'components/organism/Generic/WorkflowCardsGrid';
import { mergeWorkflowDataWithConfig } from 'utils/ppaHelpers';

export function useFetchWorkflowCards(config: WorkflowCardData[]) {
    const { data: workflowCardsData, isLoading, isPending } = useQuery({
        queryKey: ['workflow-cards-data'],
        queryFn: async () => {
            const response = await axios.get(ppaUrls.getWorkFlowsDataUrl);
            return response?.data?.workflows || [];
        },
        enabled: Boolean(process.env.REACT_APP_TENANT_ID),
    });

    const data = mergeWorkflowDataWithConfig(workflowCardsData || [], config) as WorkflowCardData[];

    return { data, isLoading, isPending };
}
